import { FormControl, InputLabel, Select } from '@mui/material'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import OutlinedInput from '@mui/material/OutlinedInput'

import CustomButton from 'Components/CustomButton/CustomButton'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { currentDate } from 'utils/helpers'
import { Input } from '../../../Components/Input'
import { makeGetRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const ITEM_HEIGHT = 50
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 350,
    },
  },
}
export default function CreateGroup({ fetchGroups }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(false)
  const [contacts, SetContacts] = useState([])
  const [personContact, setPersonContact] = useState([])
  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    setPersonContact(typeof value === 'string' ? value.split(',') : value)
  }
  const handleClickOpen = async () => {
    setOpen(true)
    const contacts = await makeGetRequest('/api/Social/get-contact-for-groups', {}, true)
    SetContacts(contacts.data)
  }

  const handleClose = () => {
    setOpen(false)
  }
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Date: currentDate(),
    },
  })
  const onSubmit = (data) => {
    let url = '/api/Social/create-group/'

    let formData = new FormData()

    if (data.Nom !== null) {
      formData.append('Nom du groupe', data.Nom)
    }
    if (data.Description !== null) {
      formData.append('Description', data.Description)
    }
    formData.append('Contacts', personContact)
    for (let [key, value] of formData) {
    }
    let response = makePostRequest(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      {},
      true,
    )
      .then((res) => {
        fetchGroups()
      })
      .catch((err) => {
        console.log(err.response.data)
      })
    if (response.status === 201) {
      handleClose()
    }
    setOpen(false)
  }
  return (
    <>
      {/* LAP-733 (GE022) */}
      <CustomButton onClick={handleClickOpen}>{t('contacts.btnCreate')}</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        {/* LAP-733 (GE022) */}
        <DialogTitle>{t('contacts.dlgManageGroup')}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                size: 'small',
                type: 'text',
                required: true,
              }}
              name="Nom"
              label="Nom du Groupe"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
              }}
              name="Description"
              label="Désignation"
            />
            <FormControl style={{ m: 1, width: '386px' }}>
              <InputLabel>List of contacts</InputLabel>
              <Select
                multiple
                value={personContact}
                onChange={handleChange}
                input={<OutlinedInput label="List of contacts" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {contacts.map((name) => (
                  <MenuItem key={name.id} value={name.NomPreNom}>
                    <Checkbox checked={personContact.indexOf(name.NomPreNom) > -1} />
                    <ListItemText primary={name.NomPreNom} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
